import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_AUTHENTICATE_USER_URL } from "constants/apiUrls";

import { AuthTransaction } from "../types/authTransaction";
import { UserCredentials } from "../types/userCredentials";
import { OktaError } from "../../../types/oktaError/oktaError";

import getApiClient from "lib/apiClient/getApiClient";

function useAuthenticateUser(): UseMutationResult<
  AuthTransaction,
  OktaError,
  UserCredentials
> {
  return useMutation({
    mutationFn: async (authData) => {
      const response = await getApiClient()(API_AUTHENTICATE_USER_URL, {
        method: "POST",
        body: JSON.stringify(authData),
      });

      const data = await response.json();

      return response.ok ? Promise.resolve(data) : Promise.reject(data);
    },
  });
}

export default useAuthenticateUser;
